import React from "react";

const GoogleIcon = () => {
  const clipPathId = "clip0_google_icon";
  const maskId = "mask0_google_icon";

  return (
    <svg
      width="26"
      height="26"
      viewBox="0 0 26 26"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <clipPath id={clipPathId}>
          <rect width="26" height="26" fill="white" />
        </clipPath>
        <mask
          id={maskId}
          maskUnits="userSpaceOnUse"
          x="4"
          y="4"
          width="18"
          height="18"
        >
          <path
            d="M21.0099 11.3662H13.2093V14.5957H17.6994C17.2808 16.6474 15.5304 17.8252 13.2093 17.8252C10.4695 17.8252 8.26255 15.6216 8.26255 12.886C8.26255 10.1504 10.4695 7.9468 13.2093 7.9468C14.3889 7.9468 15.4543 8.36474 16.2915 9.04863L18.7268 6.61701C17.2428 5.32522 15.3402 4.52734 13.2093 4.52734C8.56696 4.52734 4.83789 8.25075 4.83789 12.886C4.83789 17.5213 8.56696 21.2447 13.2093 21.2447C17.395 21.2447 21.2001 18.2052 21.2001 12.886C21.2001 12.3921 21.124 11.8602 21.0099 11.3662Z"
            fill="white"
          />
        </mask>
      </defs>

      <g clipPath={`url(#${clipPathId})`}>
        <circle cx="13" cy="13" r="12.5" fill="#E0E0E0" />
        <circle cx="13" cy="13" r="12.31" fill="white" />
        <g mask={`url(#${maskId})`}>
          <path
            d="M4.0769 17.8252V7.94678L10.5457 12.886L4.0769 17.8252Z"
            fill="#FBBC05"
          />
          <path
            d="M4.0769 7.94691L10.5457 12.8861L13.2093 10.5685L22.3417 9.08673V3.76758H4.0769V7.94691Z"
            fill="#EA4335"
          />
          <path
            d="M4.0769 17.8253L15.4924 9.08673L18.4985 9.46667L22.3417 3.76758V22.0047H4.0769V17.8253Z"
            fill="#34A853"
          />
        </g>
      </g>
    </svg>
  );
};

export default GoogleIcon;
